import React, { useState, useEffect } from "react";
import SendMails from "./SendMails";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";

function SendMailsRoute() {
  const [authorized, setAuthorized] = useState(false);
  const [gmail, setGmail] = useState("");
  const [appPassword, setAppPassword] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [serverMessage, setServerMessage] = useState("");
  const FRONTEND_SECRET = process.env.REACT_APP_FRONTEND_SECRET;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const storedGmail = localStorage.getItem("gmail");
    const storedPassword = localStorage.getItem("appPassword");
    const storedSecret = localStorage.getItem("secretKey");

    if (storedGmail && storedPassword && storedSecret === FRONTEND_SECRET) {
      setGmail(storedGmail);
      setAppPassword(storedPassword);
      setAuthorized(true);
    }
  }, []);

  const pingServer = async () => {
    try {
      const res = await fetch(BACKEND_URL, {
        headers: { "x-api-key": API_KEY },
        method: "GET",
      });
      return res.ok;
    } catch (err) {
      console.log("err", err);
      return false;
    }
  };

  useEffect(() => {
    setServerMessage("Please wait while we start the server!");

    pingServer()
      .then((isServerUp) => {
        if (isServerUp) {
          setServerMessage("");
        } else {
          setServerMessage("Server is not available!");
        }
      })
      .catch(() => {
        setServerMessage("Server is not available!");
      });

    return () => {
      setServerMessage("");
    };
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();

    if (secretKey !== FRONTEND_SECRET) {
      alert("Incorrect secret key");
      setSecretKey("");
      return;
    }

    if (!gmail || !appPassword) {
      alert("Please enter Gmail ID and App Password");
      return;
    }

    localStorage.setItem("gmail", gmail);
    localStorage.setItem("appPassword", appPassword);
    localStorage.setItem("secretKey", secretKey);

    setAuthorized(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    setGmail("");
    setAppPassword("");
    setSecretKey("");
    setAuthorized(false);
  };

  if (serverMessage) {
    return (
      <Modal show centered backdrop="static" keyboard={false}>
        <Modal.Body>
          <Alert variant="dark" className="d-flex align-items-center m-4">
            <Spinner animation="border" size="sm" className="mx-2" />
            {serverMessage}
          </Alert>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      {/* Login Modal */}
      {!authorized && (
        <Modal show centered backdrop="static" keyboard={false}>
          <Modal.Header className="border-0">
            <Modal.Title className="mx-auto fw-semibold">
              Access Restricted
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Gmail ID</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Gmail ID"
                  value={gmail}
                  onChange={(e) => setGmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="d-flex align-items-center gap-2">
                  App Password
                  <a
                    href="https://myaccount.google.com/apppasswords"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted"
                    style={{ cursor: "pointer" }}
                  >
                    <FaInfoCircle size={14} />
                  </a>
                </Form.Label>

                <Form.Control
                  type="password"
                  placeholder="Enter App Password"
                  value={appPassword}
                  onChange={(e) => setAppPassword(e.target.value)}
                  required
                />

                <Form.Text className="text-muted">
                  Generate a Gmail App Password (requires 2FA).
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Secret Key</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter Secret Key"
                  value={secretKey}
                  onChange={(e) => setSecretKey(e.target.value)}
                  required
                />
              </Form.Group>

              <div className="d-grid">
                <Button variant="dark" type="submit">
                  Login
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}

      {/* SendMails Modal */}
      {authorized && (
        <Modal show centered scrollable size="lg">
          <Modal.Header className="border-0 d-flex justify-content-between align-items-center">
            <div className="fw-medium">
              Logged in as: <span className="text-muted">{gmail}</span>
            </div>
            <Button variant="outline-danger" size="sm" onClick={handleLogout}>
              Logout
            </Button>
          </Modal.Header>

          <Modal.Body>
            <SendMails gmail={gmail} appPassword={appPassword} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default SendMailsRoute;
